import { LessonIndexView } from '../../../types/lessons';
import { action, computed, observable } from 'mobx';
import { LessonActivationApis } from '../../../apis/lessonActivations';
import { SectionId } from '../../../../commonv3/types/sections';
import { SectionUid } from '../../../types/sections';
import { SectionEventType } from '../../../../commonv3/types/section_events';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SubmitState } from '../../../../commonv3/states/SubmitState';

export class LessonState {
    @observable lesson: LessonIndexView;
    @observable submitState: SubmitState = new SubmitState();
    constructor(lesson: LessonIndexView) {
        this.lesson = lesson;
    }

    @action.bound
    async activate() {
        await this.submitState.operate(async () => {
            await LessonActivationApis.create(this.lesson.id);
            this.update((l) => ({ ...l, activated: true }));
            await GlobalStatesV3.currentUser.reloadUser();
        });
    }

    @computed
    get loading() {
        return this.submitState.submitting;
    }

    @computed
    get isActivated() {
        return this.lesson.activated;
    }

    @computed
    get requiredTokenAmount() {
        return this.lesson.required_token_amount;
    }

    async onSectionEvent(sectionId: SectionId, sectionUid: SectionUid, eventType: SectionEventType) {
        switch (eventType) {
            case SectionEventType.SECTION_OPENED:
                this.update((l) => ({ ...l, last_opened_section_uid: sectionUid }));
                return;
        }
    }

    @action.bound
    private update(func: (l: LessonIndexView) => LessonIndexView) {
        this.lesson = func(this.lesson);
    }
}
